import { Observable, throwError as observableThrowError } from 'rxjs';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';

import { isNullOrUndefined } from 'util';

import { MensagensService } from '../../../constantes/mensagens.service';
import { RespostaLoginCharon } from '../../charon/models/resposta-login-charon.model';
import { AppSettingsService } from '../../configuracao/services/app-settings.service';
import { RequisicaoLoginCharon } from '../models/requisicao-login-charon.model';
import { SessaoService } from './sessao.service';

@Injectable()
export class LogonCharonService {
  constructor(
    private http: HttpClient,
    private servicoConfiguracao: AppSettingsService,
    private sessaoService: SessaoService
  ) {}

  /**
   * Método responsável por realizar a autenticação de um usuário no serviço do Caronte
   * @param {RequisicaoLoginCharon} requisicao Dados do Usuário
   * @returns {Observable<RequisicaoLoginCharon>} Dados da Autenticação
   * @memberof LogonRouterService
   */
  async autenticar(
    requisicao: RequisicaoLoginCharon
  ): Promise<RespostaLoginCharon> {
    if (!isNullOrUndefined(requisicao) && !isNullOrUndefined(requisicao.body)) {
      let session = await this.sessaoService.getCharonSession().toPromise();
      var links =
        session.body.links[
          this.servicoConfiguracao.environment.charon.action_logon
        ];
      const bodyRequest = JSON.stringify({ body: requisicao.body });
      const token = session.headers.get(
        this.servicoConfiguracao.environment.charon.session_name
      );

      const httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
          .set(this.servicoConfiguracao.environment.charon.session_name, token)
          .set('x-itau-correlationID', token),
        observe: 'response' as 'response',
      };

      return this.http
        .post(links.href, bodyRequest, httpOptions)
        .pipe(
          map((response: any) => {
            const preLogin: RespostaLoginCharon = response.body;
            preLogin.tokenAutenticacao = response.headers.get(
              this.servicoConfiguracao.environment.charon.session_name
            );
            preLogin.links = session.body.links;
            preLogin.charonTokenIssuedDate = new Date();
            return preLogin;
          }),
          catchError((erro: any) => {
            return observableThrowError(erro);
          })
        )
        .toPromise();
    } else {
      return observableThrowError(
        new Error(MensagensService.mensagens.charon.parametrosInvalidos)
      ).toPromise();
    }
  }

  /**
   * Método responsável por realizar a troca de senha de um usuário no serviço do Caronte
   * @param {RequisicaoLoginCharon} requisicao Dados do Usuário
   * @memberof LogonRouterService
   */
  async trocaSenha(
    requisicao: RequisicaoLoginCharon
  ): Promise<RespostaLoginCharon> {
    if (!isNullOrUndefined(requisicao) && !isNullOrUndefined(requisicao.body)) {
      let session = await this.sessaoService.getCharonSession().toPromise();
      var links =
        session.body.links[
          this.servicoConfiguracao.environment.charon.action_reset
        ];
      const bodyRequest = JSON.stringify({ body: requisicao.body });
      const httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
          .set(
            'X-Charon-Session',
            session.headers.get(
              this.servicoConfiguracao.environment.charon.session_name
            )
          )
          .set('x-itau-apikey', 'x-itau-apikey'),
        observe: 'response' as 'response',
      };

      return this.http
        .post(links.href, bodyRequest, httpOptions)
        .pipe(
          map((response: any) => {
            const preLogin: RespostaLoginCharon = response.body;
            preLogin.tokenAutenticacao = response.headers.get(
              this.servicoConfiguracao.environment.charon.session_name
            );
            return preLogin;
          }),
          catchError((erro: any) => {
            return observableThrowError(erro);
          })
        )
        .toPromise();
    } else {
      return observableThrowError(
        new Error(MensagensService.mensagens.charon.parametrosInvalidos)
      ).toPromise();
    }
  }
}
